import { Fragment } from 'preact'

import type { CookieConsentTranslator } from '#src/assets/lib/i18n.ts'
import { Paragraph } from '#src/assets/ui/shared/components/Paragraph.tsx'

export function PolicySectionOverview({ t }: { t: CookieConsentTranslator }) {
  const overviewItems = [
    t('policyOverviewItem.howWeUse'),
    t('policyOverviewItem.types'),
    t('policyOverviewItem.duration'),
    t('policyOverviewItem.settings'),
    t('policyOverviewItem.contact'),
  ]

  return (
    <Fragment>
      <Paragraph>{t('policyOverviewIntro')}</Paragraph>
      <OverviewList items={overviewItems} />
    </Fragment>
  )
}

function OverviewList({ items }: { items: string[] }) {
  return (
    <ul
      style={{
        display: 'block',
        listStyle: 'disc',
        margin: '0 0 1rem',
        paddingLeft: '1.5rem',
      }}
    >
      {items.map(itemText => (
        <OverviewListItem key={itemText} itemText={itemText} />
      ))}
    </ul>
  )
}

function OverviewListItem({ itemText }: { itemText: string }) {
  return (
    <li style={{ display: 'list-item', margin: '0.25rem 0' }}>{itemText}</li>
  )
}
